module.exports = __webpack_public_path__ + "img/img (24).4deb817b.jpg";